<template>
  <div class="listDates">
    <smoothReflow>
      <button
        class="otherDatesSelection btn"
        v-bind:class="{ disable: selectedDay == null, 'btn-primary': selectedDay !== null }"
        @click.self="togglePicker()"
        :disabled="isLoadingListPerDay"
      >
        <span class="selectedDate" @click.self="togglePicker()"
          ><template v-if="this.selectedDay == null">{{ $t('GUIDED_TOURS_ANY_DATE') }}</template>
          <template v-else>{{ selectedDayLabel }}</template></span
        >
        <DatePicker
          class="datePicker"
          ref="datePicker"
          :allDays="true"
          mode="range"
          :except="allDaysExcept"
          positionElement=".pickerToggler"
          :modelValue="[this.selectedDay, this.endDateURL]"
          @update:modelValue="
            (v) => {
              newDatePickerDay(v);
            }
          "
        /><button class="closeIcon" v-if="this.selectedDay" v-on:click="setSelectedDayLocal(null)">
          <Icon icon="close" />
        </button>
      </button>
      <template v-if="!areAllDisabled()">
        <button
          v-on:click="newDatePickerDay(today + ' ' + today)"
          v-bind:class="{ disable: !(selectedDay === today && endDateURL === selectedDay) }"
          :disabled="!showToday || isLoadingListPerDay"
        >
          {{ todayLabel }}
        </button>
        <button
          v-on:click="newDatePickerDay(tomorrow + ' ' + tomorrow)"
          v-bind:class="{ disable: !(selectedDay === tomorrow && endDateURL === selectedDay) }"
          :disabled="!showTomorrow || isLoadingListPerDay"
        >
          {{ tomorrowLabel }}
        </button>
        <button
          v-on:click="newDatePickerDay(inTwoDays + ' ' + inTwoDays)"
          v-bind:class="{ disable: !(selectedDay === inTwoDays && endDateURL === selectedDay) }"
          :disabled="!showInTwoDays || isLoadingListPerDay"
        >
          {{ inTwoDaysLabel }}
        </button>
        <button
          v-on:click="newDatePickerDay(inThreeDays + ' ' + inThreeDays)"
          v-bind:class="{ disable: !(selectedDay === inThreeDays && endDateURL === selectedDay) }"
          :disabled="!showInThreeDays || isLoadingListPerDay"
        >
          {{ inThreeDaysLabel }}
        </button>
        <button
          v-on:click="newDatePickerDay(inFourDays + ' ' + inFourDays)"
          v-bind:class="{ disable: !(selectedDay === inFourDays && endDateURL === selectedDay) }"
          :disabled="!showInFourDays || isLoadingListPerDay"
        >
          {{ inFourDaysLabel }}
        </button>
      </template>
    </smoothReflow>
  </div>
</template>

<script>
import moment from 'moment-mini';
import { mapActions, mapState } from 'vuex';
import formater from '../../lib/formater';
import DatePicker from '../Form/DatePicker.vue';
import Icon from '../Icon.vue';

export default {
  name: 'listDates',
  data() {
    return {
      endDateStr: '',
      endDateURL: '',
    };
  },
  components: { DatePicker, Icon },
  computed: {
    ...mapState({
      selectedDay: (state) => state.guidedTours.selectedDay,
      isToursPerDateLoaded: (state) => state.guidedTours.isToursPerDateLoaded,
      toursPerDate: (state) => state.guidedTours.data.toursPerDate,
      isLoadingListPerDay: (state) => state.guidedTours.isLoadingListPerDay,
      locale: (state) => state.locale,
      showToday: (state) => state.guidedTours.nextFewDays.today,
      showTomorrow: (state) => state.guidedTours.nextFewDays.tomorrow,
      showInTwoDays: (state) => state.guidedTours.nextFewDays.inTwoDays,
      showInThreeDays: (state) => state.guidedTours.nextFewDays.inThreeDays,
      showInFourDays: (state) => state.guidedTours.nextFewDays.inFourDays,
    }),
    allDaysExcept() {
      const days = [];
      if (this.isDisabled(this.today)) {
        days.push(this.today);
      }
      if (this.isDisabled(this.tomorrow)) {
        days.push(this.tomorrow);
      }
      if (this.isDisabled(this.inTwoDays)) {
        days.push(this.inTwoDays);
      }
      if (this.isDisabled(this.inThreeDays)) {
        days.push(this.inThreeDays);
      }
      if (this.isDisabled(this.inFourDays)) {
        days.push(this.inFourDays);
      }
      return days;
    },
    selectedDayLabel() {
      let output = formater.date(this.selectedDay);
      if (this.endDateStr && this.endDateStr !== output) {
        output += ' → ' + this.endDateStr;
      }
      return output;
    },
    todayLabel() {
      return `${this.$t('GUIDED_TOURS_TODAY')} (${formater.date(moment().format('YYYY-MM-DD'))})`;
    },
    today() {
      return `${moment().format('YYYY-MM-DD')}`;
    },
    tomorrowLabel() {
      return `${this.$t('GUIDED_TOURS_TOMORROW')} (${formater.date(moment().add(1, 'day').format('YYYY-MM-DD'))})`;
    },
    tomorrow() {
      return `${moment().add(1, 'day').format('YYYY-MM-DD')}`;
    },
    inTwoDaysLabel() {
      return `${moment()
        .add(2, 'day')
        .toDate()
        .toLocaleString(this.locale, {
          weekday: 'long',
        })} (${formater.date(moment().add(2, 'day').format('YYYY-MM-DD'))})`;
    },
    inTwoDays() {
      return `${moment().add(2, 'day').format('YYYY-MM-DD')}`;
    },
    inThreeDaysLabel() {
      return `${moment()
        .add(3, 'day')
        .toDate()
        .toLocaleString(this.locale, {
          weekday: 'long',
        })} (${formater.date(moment().add(3, 'day').format('YYYY-MM-DD'))})`;
    },
    inThreeDays() {
      return `${moment().add(3, 'day').format('YYYY-MM-DD')}`;
    },
    inFourDaysLabel() {
      return `${moment()
        .add(4, 'day')
        .toDate()
        .toLocaleString(this.locale, {
          weekday: 'long',
        })} (${formater.date(moment().add(4, 'day').format('YYYY-MM-DD'))})`;
    },
    inFourDays() {
      return `${moment().add(4, 'day').format('YYYY-MM-DD')}`;
    },
  },
  methods: {
    ...mapActions({
      setSelectedDay: 'guidedTours/setSelectedDay',
      listGuidedToursPerDay: 'guidedTours/listPerDay',
    }),
    areAllDisabled() {
      return (
        this.showToday &&
        this.showTomorrow &&
        this.showInTwoDays &&
        this.showInThreeDays &&
        this.showInFourDays
      );
    },
    setSelectedDayLocal(d) {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      if (d) {
        query.date = d;
        query.dateEnd = this.endDateURL;
      } else {
        query.date = undefined;
        query.dateEnd = undefined;
      }
      let queryString = '?';
      Object.keys(query).forEach((k) => {
        if (typeof query[k] !== 'undefined') {
          if (queryString !== '?') {
            queryString += '&';
          }
          queryString += k + '=' + query[k];
        }
      });
      //history.replaceState(history.state, '',this.$route.path+queryString)
      this.$router.replace({ query });
      this.setSelectedDay(d);
    },
    isDisabled(d) {
      if (typeof this.toursPerDate[d] === 'undefined') {
        return true;
      }
      if (this.toursPerDate[d].length === 0) {
        return true;
      }
      return false;
    },
    newDatePickerDay(dates) {
      this.endDateStr = '';
      let duration = 0;
      const start = dates.split(' ')[0];
      if (typeof dates.split(' ')[1] !== 'undefined') {
        const end = dates.split(' ')[1];
        const startMoment = moment(start, 'YYYY-MM-DD');
        const endMoment = moment(end, 'YYYY-MM-DD');
        this.endDateStr = formater.date(endMoment.format('YYYY-MM-DD'));
        this.endDateURL = endMoment.format('YYYY-MM-DD');
        duration = moment.duration(endMoment.diff(startMoment)).asDays();
      }
      if (typeof dates.split(' ')[1] !== 'undefined') {
        this.listGuidedToursPerDay({ day: start, lookahead: duration }).then(() => {
          this.setSelectedDayLocal(start);
        });
      }
    },
    togglePicker() {
      this.$refs.datePicker.togglePicker();
    },
  },
  watch: {},

  mounted() {
    this.$store
      .dispatch('guidedTours/getNextFewDays', { day: moment().format('YYYY-MM-DD'), lookahead: 4 })
      .then(() => {
        if (this.$route.query.date && this.$route.query.dateEnd) {
          this.newDatePickerDay(this.$route.query.date + ' ' + this.$route.query.dateEnd);
        } else if (this.$route.query.date) {
          //this.newDatePickerDay(this.$route.query.date+' '+this.$route.query.date)
          this.listGuidedToursPerDay({ day: this.$route.query.date, lookahead: 0 }).then(() => {});
          //this.setSelectedDayLocal(this.$route.query.date);
          this.setSelectedDay(this.$route.query.date);
        } /*else {
      this.listGuidedToursPerDay({ day: moment().format('YYYY-MM-DD'), lookahead: 4}).then(() => {})
    }*/
      });
  },
};
</script>

<style lang="scss" scoped>
.listDates {
  width: 100%;
}

.listDates > div {
  display: flex;
  flex-direction: row;
  gap: $sp;
  flex-wrap: wrap;
  min-width: 100%;
  @media screen and (max-width: $screen-sm) {
    justify-content: center;
  }
}

.disable {
  background-color: white !important;
  background-image: none !important;
  color: $text-color;
  text-shadow: none;
}

.disable:hover {
  color: $text-color;
}

.closeIcon {
  display: block;
  line-height: 10px;
  height: 24px;
  margin-left: $sp * 0.5;
  padding: 3px;

  @media screen and (max-width: $screen-sm) {
    position: absolute;
    right: $sp * 0.5;
  }
}

.closeIcon :deep(.fill) {
  fill: white !important;
}

.datePicker {
  margin-bottom: 0;
}

.datePicker :deep(.form-input) {
  display: none;
}
.datePicker :deep(.pickerToggler) {
  border: 0;
  background: transparent !important;
  box-shadow: none;
}

.datePicker :deep(.pickerToggler) {
  padding: 0;
  padding-top: 3px;
  padding-left: $sp * 0.5;
}

.disable .datePicker :deep(.pickerToggler .fill) {
  fill: $text-color !important;
}
.datePicker :deep(.pickerToggler .fill) {
  fill: white !important;
}

.datePicker :deep(label) {
  display: none;
}

.otherDatesSelection {
  position: relative;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  gap: $sp * 0.5;
  @media screen and (max-width: $screen-xs) {
    min-width: 100%;
    justify-content: center;
  }
}
</style>
